angular.module('impactx.controlChip').directive('copyToClipboardButton', function ($copyToClipboard, TranslationService, ToastService) {
    return {
        scope: {
            copyValue: "=",
        },
        restrict: 'E',
        templateUrl: 'shared/clipboard/templates/copy-to-clipboard-button.html',
        transclude: true,
        link: function (scope, element, attrs) {
            scope.copySuccessLabel = TranslationService.get("copiedToClipboard");
            scope.copyFunction = function(event) {
                event.preventDefault();
                event.stopPropagation();
                if (scope.copyValue) {
                    $copyToClipboard.copy(scope.copyValue).then(function () {
                        ToastService.openStandardToast(scope.copySuccessLabel);
                    });
                }
            }
        }
    }
});